export const gradationColors = "linear-gradient(to top, #f1f3f9, #f1f3f9)";
